import type { SearchResultTeamsMessage, TeamsMessage, SenderProfileUser, } from "../../data/schema/SubstrateSearchResponse";
import type SubstrateSearchRequest from "../../data/schema/SubstrateSearchRequest";
import { convertUtcDateTimeToRequestTimeZone } from "./converterHelpers";
import { logUsage } from "owa-analytics";
import type { MailboxInfo } from "owa-client-types";

export default function convertSearchResultTeamsMessageToTeamsMessageType(searchResultTeamsMessage: SearchResultTeamsMessage, request: SubstrateSearchRequest, mailboxInfo: MailboxInfo): TeamsMessage | undefined {
    // Ensure required properties are present
    if (!searchResultTeamsMessage.ReferenceId ||
        !searchResultTeamsMessage.InternetMessageId ||
        !searchResultTeamsMessage.DisplayTo ||
        !searchResultTeamsMessage.Sender ||
        !searchResultTeamsMessage.ClientThreadId) {
        logUsage("SearchResultConversion_TeamsMessageType_MissingRequiredProperties", mailboxInfo, {
            missingReferenceId: !searchResultTeamsMessage.ReferenceId,
            missingInternetMessageId: !searchResultTeamsMessage.InternetMessageId,
            missingDisplayTo: !searchResultTeamsMessage.DisplayTo,
            missingThreadType: !searchResultTeamsMessage.Extensions
                ?.SkypeSpaces_ConversationPost_Extension_ThreadType,
            missingTopic: !searchResultTeamsMessage.Extensions?.SkypeSpaces_ConversationPost_Extension_Topic,
            missingGroupId: !searchResultTeamsMessage.Extensions
                ?.SkypeSpaces_ConversationPost_Extension_SkypeGroupId,
            missingSender: !searchResultTeamsMessage.Sender,
            missingClientThreadId: !searchResultTeamsMessage.ClientThreadId,
        });
        return undefined;
    }
    
    return {
        ItemId: searchResultTeamsMessage.InternetMessageId,
        content: searchResultTeamsMessage.Preview,
        id: searchResultTeamsMessage.InternetMessageId,
        composeTime: searchResultTeamsMessage.DateTimeSent
            ? convertUtcDateTimeToRequestTimeZone(searchResultTeamsMessage.DateTimeSent, request)
            : undefined,
        originalArrivalTime: searchResultTeamsMessage.DateTimeReceived
            ? convertUtcDateTimeToRequestTimeZone(searchResultTeamsMessage.DateTimeReceived, request)
            : undefined,
        containerId: searchResultTeamsMessage.ClientConversationId,
        imDisplayName: searchResultTeamsMessage.Sender.EmailAddress.Name,
        senderProfile: {
            displayName: searchResultTeamsMessage.Sender.EmailAddress.Name,
            email: searchResultTeamsMessage.Sender.EmailAddress.Address,
        } as SenderProfileUser,
        displayTo: searchResultTeamsMessage.DisplayTo,
        messageType: searchResultTeamsMessage.Extensions
            ?.SkypeSpaces_ConversationPost_Extension_ThreadType ?? "",
        chatName: searchResultTeamsMessage.Extensions?.SkypeSpaces_ConversationPost_Extension_Topic ?? "",
        topicGroupId: searchResultTeamsMessage.Extensions
            ?.SkypeSpaces_ConversationPost_Extension_SkypeGroupId ?? "",
        isExpanded: false,
        clientThreadId: searchResultTeamsMessage.ClientThreadId,
        InstanceKey: searchResultTeamsMessage.ReferenceId,
        parentMessageId: searchResultTeamsMessage.Extensions
            ?.SkypeSpaces_ConversationPost_Extension_ParentMessageId,
    };
}
